import Link from '@jetbrains/ring-ui/components/link/link'
import React, {memo} from 'react'

import RegExpMatch from './RegExpMatch/RegExpMatch'

type Props = {
  className?: string
  text: string
}

const urlRegexpString =
  '(\\b(https?|ftp|file):\\/\\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])'

const renderMatched = (key: string, text: string): React.ReactNode => (
  <Link target="_blank" key={key} href={text} rel="noreferrer">
    {text.replace(/^https?:\/\//, '')}
  </Link>
)

const renderUnmatched = (key: string, text: string): React.ReactNode => (
  <span key={key}>{text}</span>
)

const renderNoMatches = (fullText: string): React.ReactNode => fullText

const renderResult = (result: React.ReactNode): React.ReactNode => result

function Description({className, text}: Props) {
  const urlRegex = new RegExp(urlRegexpString, 'gi')
  return (
    <div className={className} title={text}>
      <RegExpMatch
        text={text}
        regexp={urlRegex}
        renderMatched={renderMatched}
        renderUnmatched={renderUnmatched}
        renderNoMatches={renderNoMatches}
        renderResult={renderResult}
      />
    </div>
  )
}

export default memo<Props>(Description)
